class StoreLocator extends HTMLElement {
  constructor() {
    super();

    // Delay initialization to ensure the map is loaded
    setTimeout(() => {
      this.init();
    }, 2000);
  }

  init() {
    // Find the Stockist map iframe or container
    const mapContainer = this.querySelector(".stockist-map");
    if (mapContainer) {
      let ctrlPressed = false;

      // Listen for `Ctrl` key press
      window.addEventListener("keydown", (e) => {
        if (e.key === "Control") {
          ctrlPressed = true;
          mapContainer.style.pointerEvents = "auto"; // Enable map interactions
        }
      });

      // Listen for `Ctrl` key release
      window.addEventListener("keyup", (e) => {
        if (e.key === "Control") {
          ctrlPressed = false;
          mapContainer.style.pointerEvents = "none"; // Disable map interactions
        }
      });

      // Disable map scroll by default
      mapContainer.style.pointerEvents = "none";
    }
  }
}

customElements.define("store-locator", StoreLocator);
